import axios from "axios";
import { plainToClass } from "class-transformer";
import { validate } from "class-validator";
import { GetSettingDTO } from "../../dto";

type MutateSettingProps = {
  tierResetTime: Date;
};

let body: GetSettingDTO;

export async function mutateSettingAction(props: MutateSettingProps) {
  const token = localStorage.getItem("token");

  const params = {
    tierResetTime: props.tierResetTime,
  };

  return await axios
    .put(
      `${process.env.REACT_APP_API_ORIGIN}/1.0.0/cms/settings/update`,
      params,
      {
        headers: {
          "Content-Type": "application/json",
          "app-platform": "cms",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then(async (res) => {
      body = plainToClass(GetSettingDTO, res.data);
      const errors = await validate(body);

      if (errors.length > 0) {
        throw errors;
      }

      return res.data;
    });
}
